import { Card } from 'react-bootstrap';

interface EmptyTableStateProps {
  message: string;
}

const EmptyTableState = ({ message }: EmptyTableStateProps) => {
  return (
    <Card className="card-inactive-state">
      <Card.Body className="text-center">
        <img className="img-fluid" src="/img/illustrations/scale.svg" style={{ maxWidth: 182 }} alt="..." />
        <h1>{message}</h1>
      </Card.Body>
    </Card>
  );
};

export default EmptyTableState;
